export const INITIALIZE = {
  GIFT_CARD: 'GiftCard',
};
